import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a front-load tumble dryer, 0.6 x 0.6 x 0.85 m: the
// washer's sibling in a visibly warmer white, with a dark round door (black
// ring instead of steel) and a black control strip.
const BODY = "#e8e0d2";
const MATTE_BLACK = "#2e2e30";
const DARK_GLASS = "#3a3f44";
const STEEL = "#aab2b8";

export const tumbleDryer = defineModel({
  id: "tumble-dryer",
  batchId: "modern",
  name: "Tumble dryer",
  tags: ["modern", "interior", "appliance", "laundry", "dryer"],
  summary: "A warm-white front-load tumble dryer with a dark round door.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(0.52, 0.06, 0.44), color: MATTE_BLACK, position: [0, 0.03, -0.04] },
      // body (back flush at z = -0.3)
      { geometry: new THREE.BoxGeometry(0.6, 0.79, 0.56), color: BODY, position: [0, 0.455, -0.02] },
      // black porthole ring
      { geometry: new THREE.CylinderGeometry(0.19, 0.19, 0.04, 20), color: MATTE_BLACK, position: [0, 0.4, 0.27], rotation: [Math.PI / 2, 0, 0] },
      // dark glass door disc
      { geometry: new THREE.CylinderGeometry(0.14, 0.14, 0.05, 20), color: DARK_GLASS, position: [0, 0.4, 0.275], rotation: [Math.PI / 2, 0, 0] },
      // black control strip across the top front
      { geometry: new THREE.BoxGeometry(0.56, 0.08, 0.02), color: MATTE_BLACK, position: [0, 0.76, 0.27] },
      // control dial
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.02, 12), color: STEEL, position: [-0.2, 0.76, 0.285], rotation: [Math.PI / 2, 0, 0] },
    ];
  },
  animations: [],
});
